import { z } from 'zod';

/**
 * Venue type counts breakdown
 */
export const VenueTypeCountsSchema = z.object({
  GAMING: z.number(),
  SNOOKER: z.number(),
  KIDS_PLAYAREA: z.number(),
});

export type VenueTypeCounts = z.infer<typeof VenueTypeCountsSchema>;

/**
 * Platform-wide statistics (public, used on landing page)
 */
export const PlatformStatsSchema = z.object({
  totalVenues: z.number(),
  totalCities: z.number(),
  totalBookings: z.number(),
  totalCustomers: z.number(),
  venueTypeCounts: VenueTypeCountsSchema,
});

export type PlatformStats = z.infer<typeof PlatformStatsSchema>;
